import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/icon-arrow-left.svg'
import _imports_1 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-577d2dc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#e6eff6"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-recommend --no-pt-sp" }
const _hoisted_4 = { class: "p-recommend-back" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "戻る",
  width: "24",
  height: "24"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "書類作成 編集", -1))
const _hoisted_7 = { id: "tab-control" }
const _hoisted_8 = { class: "p-recommend-resume-status" }
const _hoisted_9 = {
  key: 0,
  class: "--group"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-recommend-resume-status__text" }, "基本情報", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-recommend-resume-status__label --label-editing" }, "入力中", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-recommend-resume-status__text" }, "基本情報", -1))
const _hoisted_14 = {
  key: 0,
  class: "p-recommend-resume-status__label --label-complete"
}
const _hoisted_15 = {
  key: 1,
  class: "p-recommend-resume-status__label --label-incomplete"
}
const _hoisted_16 = {
  key: 0,
  class: "--group"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-recommend-resume-status__text" }, "職務要約", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-recommend-resume-status__label --label-editing" }, "入力中", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-recommend-resume-status__text" }, "職務要約", -1))
const _hoisted_21 = {
  key: 0,
  class: "p-recommend-resume-status__label --label-complete"
}
const _hoisted_22 = {
  key: 1,
  class: "p-recommend-resume-status__label --label-incomplete"
}
const _hoisted_23 = {
  key: 0,
  class: "--group"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-recommend-resume-status__text" }, "職務経歴", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-recommend-resume-status__label --label-editing" }, "入力中", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-recommend-resume-status__text" }, "職務経歴", -1))
const _hoisted_28 = {
  key: 0,
  class: "p-recommend-resume-status__label --label-complete"
}
const _hoisted_29 = {
  key: 1,
  class: "p-recommend-resume-status__label --label-incomplete"
}
const _hoisted_30 = {
  key: 0,
  class: "--group"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-recommend-resume-status__text" }, "学歴", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-recommend-resume-status__label --label-editing" }, "入力中", -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-recommend-resume-status__text" }, "学歴", -1))
const _hoisted_35 = {
  key: 0,
  class: "p-recommend-resume-status__label --label-complete"
}
const _hoisted_36 = {
  key: 1,
  class: "p-recommend-resume-status__label --label-incomplete"
}
const _hoisted_37 = {
  key: 0,
  class: "--group"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-recommend-resume-status__text" }, "資格•語学", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-recommend-resume-status__label --label-editing" }, "入力中", -1))
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-recommend-resume-status__text" }, "資格•語学", -1))
const _hoisted_42 = {
  key: 0,
  class: "p-recommend-resume-status__label --label-complete"
}
const _hoisted_43 = {
  key: 1,
  class: "p-recommend-resume-status__label --label-incomplete"
}
const _hoisted_44 = { class: "p-recommend-inner -is-form" }
const _hoisted_45 = { class: "p-recommend-form__field" }
const _hoisted_46 = { class: "resume-icon-wrapper" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight" }, "履", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight" }, "職", -1))
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "tab-contents" }
const _hoisted_51 = { class: "l-wrapper_nav" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = ["href"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "前に戻る", -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = ["href"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "保存して次へ", -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = ["href"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "次へ進む", -1))
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = ["onClick"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "保存して完了", -1))
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = { class: "p-recommend-form__modal-card -is-complete" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-7" }, "書類作成を保存しました。", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-recommend-form__modal-close-area" }, null, -1))

import { getCareerInfoResumeService, updateCareerBasicInfoService, updateCareerResumeService } from '@/api/services/trnCareerService';
import Loading from '@/components/Loading.vue';
import { CareerResumeInfoDetail, TrnCareerBasicInfoUpdateForm, TrnCareerResumeUpdateForm } from '@/types';
import { domHelperUtils } from '@/utils/domHelper';
import { resumeFormUtils } from '@/utils/resumeForm';
import { AxiosError } from 'axios';
import { isArray } from 'lodash';
import { useForm } from 'vee-validate';
import { computed, nextTick, onMounted, onUnmounted, provide, ref } from 'vue';
import { RouterLink, useRoute, useRouter } from 'vue-router';
import BasicInfoForm from './basicinfo/BasicInfoForm.vue';
import EducationForm from './education/EducationForm.vue';
import QualificationsForm from './qualifications/QualificationsForm.vue';
import WorkExperienceForm from './workexperience/WorkExperienceForm.vue';
import WorkSummaryForm from './worksummary/WorkSummaryForm.vue';
import ResumeOutputModal from './ResumeOutputModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResumeFormView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const isLoading = ref(false);
const showModal = ref(false);
const isModalActive = ref(false);
const isDisabledSubmit = ref(false);
const careerData = ref<CareerResumeInfoDetail>();
const resumseForm = useForm();
const isResumeOutputModalOpen = ref(false);

const openModal = () => {
  isModalActive.value = true;
};
const closeModal = () => {
  isModalActive.value = false;
};
const handleShowModal = (action: boolean) => {
  showModal.value = action;
};

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

// 1. タブの順序を定義する配列を追加
const tabOrder = ['basic-info', 'worksummary', 'workexperience', 'education', 'qualifications'];
const tabStatus = ref({
  basicInfo: {
    completed: true,
  },
  worksummary: {
    completed: true,
  },
  workexperience: {
    completed: true,
  },
  education: {
    completed: true,
  },
  qualifications: {
    completed: true,
  },
});

// 2. 完了したタブのIDを格納するリアクティブな配列を追加
const completedTabs = ref<string[]>([]);

const activeTab = ref('');

// 3. switchTab関数を修正
const switchTab = (tabId: string, isScrollTop = true) => {
  if (!tabId.startsWith('#')) {
    return;
  }

  const newTabId = tabId.substring(1);
  const oldTabId = activeTab.value;

  // タブのインデックスを取得して、前進しているか判断
  const oldIndex = tabOrder.indexOf(oldTabId);
  const newIndex = tabOrder.indexOf(newTabId);

  // 前のタブが未完了 かつ 前進している場合のみ「完了状態」として追加
  if (!completedTabs.value.includes(oldTabId) && newIndex > oldIndex) {
    completedTabs.value.push(oldTabId);
  }

  // アクティブなタブを更新
  if (oldTabId != newTabId) {
    activeTab.value = newTabId;
    router.replace({query: {tab: newTabId}});
  }

  if (isScrollTop) {
    // ページトップへスクロール
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  setTimeout(() => resumeFormUtils.updateTabStatus(resumseForm.values, tabStatus.value), 0);
};
const currentIndex = computed(() => tabOrder.indexOf(activeTab.value));
const prevTab = computed(() => currentIndex.value > 0 ? tabOrder[currentIndex.value - 1] : null);
const nextTab = computed(() => currentIndex.value < tabOrder.length - 1 ? tabOrder[currentIndex.value + 1] : null);

provide('activeTab', activeTab);
provide('prevTab', prevTab);
provide('nextTab', nextTab);
provide('switchTab', switchTab);
provide('switchTabAndValidate', switchTabAndValidate);
provide('submitBasicInfo', submitBasicInfo);

async function switchTabAndValidate(targetTabId: string) {
  const currentTab = currentIndex.value === 0 ? 'basicInfo' : tabOrder[currentIndex.value];
  const isCurrentTabValid = await resumeFormUtils.validateResumeTab(currentTab, resumseForm);
  if (isCurrentTabValid) {
    switchTab(targetTabId);
  } else {
    afterValidateFail(tabOrder[currentIndex.value]);
  }
}

async function submitResumeForm() {
  if(!isDisabledSubmit.value)
  {
      isDisabledSubmit.value = true;
      const validateResult = await resumseForm.validate();
      if (validateResult.valid) {
        const formValues = resumeFormUtils.mapToTrnCareerResumeUpdateForm(resumseForm.values);
        await submitResumeData(formValues);
      } else {
        afterValidateFail();
      }
      isDisabledSubmit.value = false;
  }
};

async function submitBasicInfo(nextTab: string) {
  if(!isDisabledSubmit.value)
  {
    isDisabledSubmit.value = true;

    const isCurrentTabValid = await resumeFormUtils.validateResumeTab('basicInfo', resumseForm);
    if (isCurrentTabValid) {
      const formValues = resumeFormUtils.mapToTrnCareerBasicInfoUpdateForm(resumseForm.values);
      if(await submitBasicInfoData(formValues)) {
        switchTab(nextTab);
      }
    } else {
      afterValidateFail(tabOrder[currentIndex.value]);
    }
    isDisabledSubmit.value = false;
  }
};

// This function will be called after validation successful
async function submitResumeData(values: TrnCareerResumeUpdateForm) {
  try {
    isLoading.value = true;
    await updateCareerResumeService(values);
    handleShowModal(true);
  } catch (error) {
    handleShowModal(false);
    const response = (error as AxiosError).response;
    if (!response || !isArray(response.data)) return;
    if (response.status == 400) {
      (response.data as any).forEach((err: {
        field: string,
        message: string,
        rejectedValue: string
      }) => {
        resumseForm.setFieldError(err.field, err.message);
      });
      await nextTick();
      await afterValidateFail('', false);

    }
  } finally {
    isLoading.value = false;
  }
}
async function submitBasicInfoData(values: TrnCareerBasicInfoUpdateForm) {
  try {
    isLoading.value = true;
    await updateCareerBasicInfoService(values);
    return true;
  } catch (error) {
    const response = (error as AxiosError).response;
    if (!response || !isArray(response.data)) return;
    if (response.status == 400) {
      (response.data as any).forEach((err: {
        field: string,
        message: string,
        rejectedValue: string
      }) => {
        resumseForm.setFieldError(err.field, err.message);
      });
      await nextTick();
      await afterValidateFail('', false);
    }
    return false;
  } finally {
    isLoading.value = false;
  }
}

async function afterValidateFail(targetTab = '', isFocusToErrEle = true){
  // First item error item
  const errMessageEle = document.querySelector('.js-error-message');

  if (!errMessageEle) return;

  const tabContentErr = errMessageEle.closest('.tab-content');
  if (!tabContentErr) {
    switchTab(nextTab.value ?? '');
    return;
  }

  const errTabId = '#' + tabContentErr.id;
  const errTabIndex = tabOrder.indexOf(tabContentErr.id);
  const targetTabIndex = tabOrder.indexOf(targetTab);
  if (targetTab && errTabIndex > targetTabIndex) {
    switchTab('#' + targetTab);
  } else {
    switchTab(errTabId, false);
  }
  const errItem = document.querySelector('.--is-error');
  if (errItem) {
    (errItem as HTMLElement).scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    if (isFocusToErrEle) {
      setTimeout(() => {
        (errItem as HTMLElement).focus();
      }, 300);
    }
  }
}

function openResumeOutputModal() {
  isResumeOutputModalOpen.value = true;
  document.body.style.overflow = 'hidden';
}

const birthDateYear = ref<number>(0);
onMounted(async () => {
  isLoading.value = true;
  careerData.value = await getCareerInfoResumeService();

  if(careerData.value.birthDate)
  {
      const arrayBirthDate = careerData.value.birthDate.split('/');
      if(arrayBirthDate.length > 0)
      {
        birthDateYear.value = Number(arrayBirthDate[0]);
      }
  }

  domHelperUtils.entryManager.initializeEntryManagement();

  isLoading.value = false;

  const tabFromUrl = route.query.tab as string; // URLから ?tab= の値を取得
  // URLに有効なタブIDが存在する場合、そのタブに切り替える
  if (tabFromUrl && tabOrder.includes(tabFromUrl)) {
    switchTab('#' + tabFromUrl);
  }
});

onUnmounted(() => {
  domHelperUtils.entryManager.removeEntryManagementEvents();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("main", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _createVNode(_unref(RouterLink), { to: "/resume/" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _hoisted_6
          ]),
          _createElementVNode("p", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", {
                class: _normalizeClass({ '--current': activeTab.value === 'basic-info' })
              }, [
                (activeTab.value === 'basic-info')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "--group",
                      href: "#basic-info",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (switchTabAndValidate('#basic-info')), ["prevent"]))
                    }, [
                      _hoisted_13,
                      (tabStatus.value.basicInfo.completed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "入力済"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_15, "未入力"))
                    ]))
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({ '--current': activeTab.value === 'worksummary' })
              }, [
                (activeTab.value === 'worksummary')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "--group",
                      href: "#worksummary",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (switchTabAndValidate('#worksummary')), ["prevent"]))
                    }, [
                      _hoisted_20,
                      (tabStatus.value.worksummary.completed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, "入力済"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_22, "未入力"))
                    ]))
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({ '--current': activeTab.value === 'workexperience' })
              }, [
                (activeTab.value === 'workexperience')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "--group",
                      href: "#workexperience",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (switchTabAndValidate('#workexperience')), ["prevent"]))
                    }, [
                      _hoisted_27,
                      (tabStatus.value.workexperience.completed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, "入力済"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_29, "未入力"))
                    ]))
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({ '--current': activeTab.value === 'education' })
              }, [
                (activeTab.value === 'education')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_33))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "--group",
                      href: "#education",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (switchTabAndValidate('#education')), ["prevent"]))
                    }, [
                      _hoisted_34,
                      (tabStatus.value.education.completed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, "入力済"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_36, "未入力"))
                    ]))
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({ '--current': activeTab.value === 'qualifications' })
              }, [
                (activeTab.value === 'qualifications')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_40))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "--group",
                      href: "#qualifications",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (switchTabAndValidate('#qualifications')), ["prevent"]))
                    }, [
                      _hoisted_41,
                      (tabStatus.value.qualifications.completed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, "入力済"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_43, "未入力"))
                    ]))
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _hoisted_48,
                _createElementVNode("button", {
                  class: "p-recommend-help",
                  type: "button",
                  onClick: _withModifiers(openResumeOutputModal, ["prevent"])
                }, "?", 8, _hoisted_49)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createVNode(BasicInfoForm, {
              "validate-field": _unref(resumseForm).validateField,
              "set-field-value": _unref(resumseForm).setFieldValue,
              openModal: openModal,
              closeModal: closeModal,
              activeTab: activeTab.value,
              isModalActive: isModalActive.value,
              "career-data": careerData.value
            }, null, 8, ["validate-field", "set-field-value", "activeTab", "isModalActive", "career-data"]),
            _createVNode(WorkSummaryForm, {
              "validate-field": _unref(resumseForm).validateField,
              "set-field-value": _unref(resumseForm).setFieldValue,
              activeTab: activeTab.value,
              "career-data": careerData.value,
              isModalActive: isModalActive.value
            }, null, 8, ["validate-field", "set-field-value", "activeTab", "career-data", "isModalActive"])
          ]),
          _createVNode(WorkExperienceForm, {
            "set-field-value": _unref(resumseForm).setFieldValue,
            "validate-field": _unref(resumseForm).validateField,
            "career-data": careerData.value,
            activeTab: activeTab.value,
            "birth-date-year": birthDateYear.value
          }, null, 8, ["set-field-value", "validate-field", "career-data", "activeTab", "birth-date-year"]),
          _createVNode(EducationForm, {
            "set-field-value": _unref(resumseForm).setFieldValue,
            "validate-field": _unref(resumseForm).validateField,
            "career-data": careerData.value,
            activeTab: activeTab.value
          }, null, 8, ["set-field-value", "validate-field", "career-data", "activeTab"]),
          _createVNode(QualificationsForm, {
            "set-field-value": _unref(resumseForm).setFieldValue,
            "validate-field": _unref(resumseForm).validateField,
            "career-data": careerData.value,
            "submit-fn": submitResumeForm,
            activeTab: activeTab.value
          }, null, 8, ["set-field-value", "validate-field", "career-data", "activeTab"])
        ])
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("a", {
          class: "g-pagetop",
          href: "#",
          onClick: _withModifiers(scrollToTop, ["prevent"]),
          "aria-label": "ページトップへ戻る"
        }, _hoisted_54, 8, _hoisted_52)
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#footer-resume-form" }, [
      (_unref(prevTab))
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "p-recommend-form__send -is-prev",
            href: `#${_unref(prevTab)}`,
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (switchTabAndValidate(`#${_unref(prevTab)}`)), ["prevent"]))
          }, _hoisted_57, 8, _hoisted_55))
        : _createCommentVNode("", true),
      (activeTab.value === 'basic-info')
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "p-recommend-form__send -is-next",
            href: `#${_unref(nextTab)}`,
            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (submitBasicInfo(`#${_unref(nextTab)}`)), ["prevent"]))
          }, _hoisted_60, 8, _hoisted_58))
        : (_unref(nextTab))
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              class: "p-recommend-form__send -is-next",
              href: `#${_unref(nextTab)}`,
              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (switchTabAndValidate(`#${_unref(nextTab)}`)), ["prevent"]))
            }, _hoisted_63, 8, _hoisted_61))
          : _createCommentVNode("", true),
      (activeTab.value === 'qualifications')
        ? (_openBlock(), _createElementBlock("a", {
            key: 3,
            class: _normalizeClass(["p-recommend-form__send", { 'disabled-link': isDisabledSubmit.value }]),
            href: "#",
            onClick: _withModifiers(submitResumeForm, ["prevent"]),
            role: "button"
          }, _hoisted_66, 10, _hoisted_64))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("div", {
        class: _normalizeClass(["p-recommend-form__modal js-modal-container", { 'is-active': showModal.value }]),
        id: "send-complete"
      }, [
        _createElementVNode("div", _hoisted_67, [
          _createVNode(_unref(RouterLink), {
            class: "p-recommend-form__modal-help-close js-modal-close-trigger",
            to: "/resume/"
          }),
          _hoisted_68,
          _createVNode(_unref(RouterLink), {
            class: "p-recommend-form__modal-help-close-2",
            to: "/resume/"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 閉じる ")
            ]),
            _: 1
          })
        ]),
        _hoisted_69
      ], 2)
    ])),
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createVNode(ResumeOutputModal, {
      isOpen: isResumeOutputModalOpen.value,
      "onUpdate:isOpen": _cache[8] || (_cache[8] = ($event: any) => ((isResumeOutputModalOpen).value = $event))
    }, null, 8, ["isOpen"])
  ], 64))
}
}

})